// extracted by mini-css-extract-plugin
export default {"container":"VWG1y","left":"CXBX9","right":"HZonQ"};